import { createContext, useContext } from 'react';

// Card-level toggle: when `showDiff` is false the diff primitives render the clean "after"
// text instead of the inline word diff. Defaults to true so a WordDiff used outside a card
// (e.g. in stories) still highlights changes.
type DiffView = {
  showDiff: boolean;
};
const DiffViewContext = createContext<DiffView>({
  showDiff: true
});
export const useDiffView = () => {
  return useContext(DiffViewContext);
};
export default DiffViewContext;